module.exports = {"domain":"spr2.auth0.com","clientId":"Q61psOZP7gG7wW6UPMYnrkprZdIeljqP","audience":"https://spr2-api"}


//////////////////
// WEBPACK FOOTER
// ./auth_config.json
// module id = kMb3
// module chunks = 14